import ButtonNew from 'client/components/entities/button-new'
import FieldNew from 'client/components/entities/field-new/field-new'
import { SearchResults } from 'client/components/entities/search-results'
import BlogPostTitleNew from 'client/pages/blog/entities/BlogPostTItleNew'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogContentPlaceholderInterface } from 'common/types/entities/BlogContentPlaceholderInterface'
import { BlogPostCategoriesInterface } from 'common/types/entities/BlogPostCategoriesInterface'
import { BlogPostContentPlaceholderInterface } from 'common/types/entities/BlogPostContentPlaceholderInterface'
import { BlogPostDateInterface } from 'common/types/entities/BlogPostDateInterface'
import { BlogPostImageInterface } from 'common/types/entities/BlogPostImageInterface'
import { BlogPostListingInterface } from 'common/types/entities/BlogPostListingInterface'
import { BlogPostTitleInterface } from 'common/types/entities/BlogPostTitleInterface'
import { BulletListInterface } from 'common/types/entities/BulletListInterface'
import { ButtonInterface } from 'common/types/entities/button-interface'
import { ContactUsInterface } from 'common/types/entities/ContactUsInterface'
import { ContactUsButtonInterface } from 'common/types/entities/contact-us-button-interface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { FieldInterface } from 'common/types/entities/field-interface'
import { LatestBlogPostsCarouselInterface } from 'common/types/entities/LatestBlogPostsCarouselInterface'
import { LatestBlogPostsInterface } from 'common/types/entities/LatestBlogPostsInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { SearchResultsInterface } from 'common/types/entities/search-results-interface'
import { TextAreaInterface } from 'common/types/entities/TextAreaInterface'
import { TextInterface } from 'common/types/entities/TextInterface'
import React from 'react'
import { Search } from 'src/editor/shared/entities/search'
import { AttachmentsInterface } from 'src/shared/types/entities/attachments-interface'
import { SearchInterface } from 'src/shared/types/entities/search-interface'
import { BreadcrumbsInterface } from '../../../common/types/entities/BreadcrumbsInterface'
import BlogLatestPosts from '../blog-page/entities/BlogLatestPosts'
import BlogPostListing from '../blog-page/entities/BlogPostListing'
import LatestBlogPostsCarousel from '../blog-page/entities/LatestBlogPostsCarousel'
import Attachments from '../contact-us/entities/Attachments'
import ContactUs from '../contact-us/entities/ContactUs'
import ContactUsField from '../contact-us/entities/ContactUsField'
import ContactUsButton from '../contact-us/entities/contact-us-button'
import Recaptcha from '../contact-us/entities/Recaptcha'
import TextArea from '../contact-us/entities/TextArea'
import createCommonEntityElement from '../createCommonEntityElement'
import BlogContentPlaceholderNew from './entities/BlogContentPlaceholderNew'
import BlogPostCategoriesNew from './entities/BlogPostCategories'
import BlogPostContentPlaceholderNew from './entities/BlogPostContentPlaceholderNew'
import BlogPostDateNew from './entities/BlogPostDateNew'
import BlogPostImage from './entities/BlogPostImage'
import Breadcrumbs from './entities/Breadcrumbs'
import BlogBulletList from './entities/blog-bullet-list'
import Text from './entities/Text'

type AdditionalProps = {
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

export default function createEntityElementForBlog(
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) {
  switch (entity.type) {
    case EntityTypeEnum.BlogPostContentPlaceholder:
      return (
        <BlogPostContentPlaceholderNew
          entity={entity as BlogPostContentPlaceholderInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BlogPostListing:
      return (
        <BlogPostListing
          entity={entity as BlogPostListingInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.SearchResults:
      return (
        <SearchResults
          entity={entity as SearchResultsInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Search:
      return <Search entity={entity as SearchInterface} {...additionalProps} />
    case EntityTypeEnum.LatestBlogPosts:
      return (
        <BlogLatestPosts
          entity={entity as LatestBlogPostsInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BlogPostImage:
      return (
        <BlogPostImage
          entity={entity as BlogPostImageInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BlogPostTitle:
      return (
        <BlogPostTitleNew
          entity={entity as BlogPostTitleInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BlogPostDate:
      return (
        <BlogPostDateNew
          entity={entity as BlogPostDateInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Breadcrumbs:
      return (
        <Breadcrumbs
          entity={entity as BreadcrumbsInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BlogPostCategories:
      return (
        <BlogPostCategoriesNew
          entity={entity as BlogPostCategoriesInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.ContactUs:
      return (
        <ContactUs entity={entity as ContactUsInterface} {...additionalProps} />
      )
    case EntityTypeEnum.TextArea:
      return (
        <TextArea entity={entity as TextAreaInterface} {...additionalProps} />
      )
    case EntityTypeEnum.Field:
      return <FieldNew entity={entity as FieldInterface} {...additionalProps} />
    case EntityTypeEnum.ContactUsField:
      return (
        <ContactUsField
          entity={entity as FieldInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Recaptcha:
    case EntityTypeEnum.ContactUsRecaptcha:
      return (
        <Recaptcha entity={entity as RecaptchaInterface} {...additionalProps} />
      )
    case EntityTypeEnum.Button:
      return (
        <ButtonNew entity={entity as ButtonInterface} {...additionalProps} />
      )
    case EntityTypeEnum.ContactUsButton:
      return (
        <ContactUsButton
          entity={entity as ContactUsButtonInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Text:
      return <Text entity={entity as TextInterface} {...additionalProps} />
    case EntityTypeEnum.BulletList:
      return (
        <BlogBulletList
          entity={entity as BulletListInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Attachments:
      return (
        <Attachments
          entity={entity as AttachmentsInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BlogContentPlaceholder:
      return (
        <BlogContentPlaceholderNew
          entity={entity as BlogContentPlaceholderInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.LatestBlogPostsCarousel:
      return (
        <LatestBlogPostsCarousel
          entity={entity as LatestBlogPostsCarouselInterface}
          {...additionalProps}
        />
      )
    default:
      return createCommonEntityElement(entity, additionalProps)
  }
}
